import type { TOC } from '@ember/component/template-only';
import { PrismButton } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';

interface SettingsDrawerNavigationHeaderSignature {
  Args: {
    isDrawerOpen: boolean;
    toggleNavbar: () => void;
  };
}

const SettingsDrawerNavigationHeader = <template>
  <div class="settings-header">
    {{#if @isDrawerOpen}}
      <h4>{{t "menu.settings"}}</h4>
    {{/if}}
    <PrismButton
      @buttonType="ghost"
      @iconBefore={{if
        @isDrawerOpen
        "sidebar-arrow-left"
        "sidebar-arrow-right"
      }}
      @onClick={{@toggleNavbar}}
    />
  </div>
</template> satisfies TOC<SettingsDrawerNavigationHeaderSignature>;

export default SettingsDrawerNavigationHeader;
